import React from 'react';
import { motion } from 'framer-motion';
import { Shield, Zap, Eye, CheckCircle2 } from 'lucide-react';
import { AnimatedSection, staggerContainer, staggerItem } from './AnimatedSection';
export function WhyAstroGuide() {
  return <AnimatedSection className="py-8 sm:py-24 bg-slate-900 text-white" data-id="element-17237">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-17238">
        <div className="text-center mb-6 sm:mb-16" data-id="element-17239">
          <h2 className="text-lg sm:text-3xl font-bold mb-2 sm:mb-4" data-id="element-17240">
            Почему выбирают Astriqo
          </h2>
          <p className="text-xs sm:text-lg text-slate-400" data-id="element-17241">
            Мы создали платформу, которой доверяют
          </p>
        </div>
        <motion.div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-6" variants={staggerContainer} initial="hidden" whileInView="visible" viewport={{
        once: true
      }} data-id="element-17242">
          {[{
          icon: <Shield className="w-5 h-5 sm:w-6 sm:h-6" data-id="element-17243" />,
          title: 'Проверенные астрологи',
          desc: 'Каждый эксперт проходит верификацию'
        }, {
          icon: <Zap className="w-5 h-5 sm:w-6 sm:h-6" data-id="element-17244" />,
          title: 'Мгновенные авто-отчёты',
          desc: 'PDF на 30+ страниц за секунды'
        }, {
          icon: <Eye className="w-5 h-5 sm:w-6 sm:h-6" data-id="element-17245" />,
          title: 'Точные алгоритмы',
          desc: 'Swiss Ephemeris — золотой стандарт'
        }, {
          icon: <CheckCircle2 className="w-5 h-5 sm:w-6 sm:h-6" data-id="element-17246" />,
          title: 'Гарантия возврата',
          desc: 'Вернём деньги в течение 7 дней'
        }].map((item, i) => <motion.div key={i} variants={staggerItem} className="flex items-start gap-3 sm:gap-4 p-3 sm:p-6 rounded-xl sm:rounded-2xl bg-white/[0.05] border border-white/[0.08]" data-id="element-17247">
              <div className="w-9 h-9 sm:w-12 sm:h-12 rounded-lg sm:rounded-xl bg-white/10 flex items-center justify-center text-indigo-300 flex-shrink-0" data-id="element-17248">
                {item.icon}
              </div>
              <div data-id="element-17249">
                <h4 className="font-bold text-white text-sm sm:text-base mb-0.5 sm:mb-1" data-id="element-17250">
                  {item.title}
                </h4>
                <p className="text-xs sm:text-sm text-slate-400 leading-relaxed" data-id="element-17251">
                  {item.desc}
                </p>
              </div>
            </motion.div>)}
        </motion.div>
      </div>
    </AnimatedSection>;
}